import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "What URLs work with this tool?",
    a: "Any Facebook Ad Library URL — direct ad links (facebook.com/ads/library/?id=…), snapshot URLs, and preview URLs are all supported. Paste it in, we handle the rest.",
  },
  {
    q: "Is it really free?",
    a: "Yes. No account, no credit card, no daily download cap. If we ever change that, existing users won't be affected.",
  },
  {
    q: "Do I need to install anything?",
    a: "Nope. Everything runs in your browser. Works on Chrome, Safari, Firefox, Edge — desktop and mobile.",
  },
  {
    q: "Do you store my downloads?",
    a: "No. Files stream directly from Meta's CDN through our proxy — we don't keep the file. Your history lives in your browser's localStorage, not on our servers.",
  },
  {
    q: "Can I download videos in HD?",
    a: "Yes — whenever the original ad was uploaded in HD, we grab the highest available quality. You can also download the SD variant and the thumbnail image.",
  },
  {
    q: "Is this legal?",
    a: "The Facebook Ad Library is a public, Meta-provided resource intended to increase ad transparency. This tool downloads only what's already publicly viewable. You are responsible for how you use the downloaded media — respect copyright.",
  },
  {
    q: "Why did my download fail?",
    a: "Some ads are geo-restricted, inactive, or contain no video/image. Double-check the URL and confirm the ad still loads in the Facebook Ad Library.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-20 md:py-28 border-t border-zinc-200 dark:border-zinc-800"
    >
      <div className="mx-auto max-w-5xl px-6">
        <div className="mb-12">
          <p className="text-xs font-mono uppercase tracking-widest text-yellow-500 mb-3">
            // FAQ
          </p>
          <h2 className="font-display font-bold text-4xl md:text-6xl text-zinc-900 dark:text-white tracking-tight leading-[0.95]">
            Questions? Answers.
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-zinc-200 dark:border-zinc-800"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-display font-bold text-zinc-900 dark:text-white text-lg md:text-xl py-6 hover:text-yellow-500 hover:no-underline transition-colors"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-zinc-400 dark:text-zinc-600 dark:text-zinc-400 text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
